// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"54886961139d0ae8f373","966":"5f2e8a3d48232a791d16"}[chunkId] + ".js";
};